import { IS_INTL } from '@/constants/global'
import { useGlobalStore } from '@/stores/global'

export async function checkNetwork() {
  const globalStore = useGlobalStore()
  if (IS_INTL) {
    fetch(import.meta.env.VITE_CHECK_NETWORK_URL, { method: 'head', mode: 'no-cors' })
      .then(() => {
        globalStore.setNetworkAvailable(true)
      })
      .catch(() => {
        globalStore.setNetworkAvailable(false)
      })
  } else {
    fetch(import.meta.env.VITE_CHECK_NETWORK_URL, { method: 'head', mode: 'no-cors' })
      .then(() => {
        globalStore.setNetworkAvailable(true)
      })
      .catch(() => {
        fetch(import.meta.env.VITE_CHECK_NETWORK_URL_BACKUP, { method: 'head', mode: 'no-cors' })
          .then(() => {
            globalStore.setNetworkAvailable(true)
          })
          .catch(() => {
            globalStore.setNetworkAvailable(false)
          })
      })
  }
}
